var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "set-url" },
    [
      _c(
        "el-form",
        {
          staticClass: "form-box",
          attrs: { model: _vm.param, size: "small", "label-width": "30%" }
        },
        [
          _c("el-form-item", { attrs: { label: "通用回调地址" } }, [
            _c(
              "div",
              { staticClass: "display_class" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入通用回调地址" },
                  model: {
                    value: _vm.param.notifyUrl,
                    callback: function($$v) {
                      _vm.$set(_vm.param, "notifyUrl", $$v)
                    },
                    expression: "param.notifyUrl"
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "submit",
                    attrs: { type: "primary", plain: "", size: "small" },
                    on: { click: _vm.updateApiInfo }
                  },
                  [_vm._v("提交")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-142530ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142530ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ent-access/setUrl.vue
// module id = yJpO
// module chunks = 48